'use client';

import React from 'react';
import { Check } from 'lucide-react';
import { useTranslation } from '@/i18n/useTranslation';

const QUESTION_KEYS_AND_FALLBACKS = [
  { key: 'landing_built_for.q1', fallback: 'Do you write?' },
  { key: 'landing_built_for.q2', fallback: 'Do you journal?' },
  { key: 'landing_built_for.q3', fallback: 'Do you like to read?' },
  {
    key: 'landing_built_for.q4',
    fallback: 'Do you save old photos, messages, or memories?',
  },
  {
    key: 'landing_built_for.q5',
    fallback: 'Do you want your achievements and milestones to mean more than a disappearing post?',
  },
] as const;

/** "Is this for me?" qualifier section -- sits after the main product explainer,
 * before the lighter era-quiz engagement widget. */
export default function BuiltForSection() {
  const { safeT } = useTranslation();

  return (
    <section className="relative px-4 py-16 sm:px-6 sm:py-20 lg:px-8">
      <div className="mx-auto max-w-3xl text-center">
        <h2 className="text-balance text-2xl font-black leading-tight tracking-tight text-slate-950 sm:text-4xl">
          {safeT('landing_built_for.title', 'Built for people who want their story to last')}
        </h2>

        <ul className="mx-auto mt-8 grid max-w-xl gap-2.5 text-left sm:mt-10">
          {QUESTION_KEYS_AND_FALLBACKS.map(({ key, fallback }) => (
            <li
              key={key}
              className="flex items-start gap-3 rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-sm"
            >
              <span
                className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full"
                style={{ background: 'rgba(13,148,136,0.12)' }}
                aria-hidden="true"
              >
                <Check size={12} style={{ color: '#0d9488' }} />
              </span>
              <p className="text-sm font-semibold leading-snug text-slate-800 sm:text-base">
                {safeT(key as any, fallback)}
              </p>
            </li>
          ))}
        </ul>

        <p className="mx-auto mt-8 max-w-2xl text-base leading-relaxed text-slate-600 sm:mt-10 sm:text-lg">
          {safeT(
            'landing_built_for.subtitle',
            'Ertzyx is built for people who want to preserve life, tell deeper stories, and build a credible record of who they are.'
          )}
        </p>
      </div>
    </section>
  );
}
